import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	actionsBtn: 'js-m-tooltip-actions__btn',
	statePopupShow: 'state-m-tooltip-actions--open',
	actionsClose: 'm-tooltip-actions__close-layer',
	actionsPopup: 'js-m-tooltip-actions__popup',
	actionItem: 'js-m-tooltip-actions__list-item',
};

@createModule('TooltipActions')
/**
 * Tooltip Actions
 *
 */
export class TooltipActions extends TerrificSpec {
	$ctx: JQuery;
	start(resolve: () => void) {
		this.$ctx = $(this._ctx);

		this.showActions();
		this.hideActions(); 

		resolve();
	}

	showActions() {
		const $actionsBtn = this.$ctx.find(`.${classes.actionsBtn}`);
		$actionsBtn.on('click',  this._openActionsPopup.bind(this));
	}

	_openActionsPopup(ev: any) {
		if (!$(ev.currentTarget).parent().hasClass(classes.statePopupShow)) {
			$(ev.currentTarget).parent().addClass(classes.statePopupShow);
		} else {
			$(ev.currentTarget).parent().removeClass(classes.statePopupShow);
		}
	}

	hideActions() {
		const $actionsClose = this.$ctx.find(`.${classes.actionsClose}`);
		$actionsClose.on('click', this._hideActionsPopup.bind(this));

		const $actionsPopup = this.$ctx.find(`.${classes.actionsPopup}`);
		$actionsPopup.on('click', this._hideActionsPopup.bind(this));
	}

	_hideActionsPopup() {
		this.$ctx.removeClass(classes.statePopupShow);
	}
 

	stop() {}
}
